import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Svg from 'src/Components/Svg'

import styles from './Status.module.scss'

const propTypes = {
  className: PropTypes.string,
  complete: PropTypes.bool
}

const Status = ({ className, complete, ...restProps }) => (
  <Svg
    viewBox='0 0 16 16'
    className={classnames(styles.root, className)}
    {...restProps}
  >
    <circle fill='none' cx='8' cy='8' r='7.5' />
    <path
      className={classnames(styles.path, complete && styles.complete)}
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M5 8.5l2 2l3.5-4'
    />
  </Svg>
)

Status.propTypes = propTypes

export default Status
